import * as bootstrap from 'bootstrap';

const myCarouselElement = document.querySelector('#carouselExampleSlidesOnly');
window.onload = function () {
  document.querySelector('.preloader').style.display = 'none';
};
const carousel = new bootstrap.Carousel(myCarouselElement, {
  interval: 4000,
  touch: true
});

const countdownDate = new Date('May 31, 2023 06:00:00').getTime();
const dayWrapEl = document.querySelector('#dayWrap');
const hrsWrapEl = document.querySelector('#hrsWrap');
const minWrapEl = document.querySelector('#minWrap');
const secWrapEl = document.querySelector('#secWrap');

export function countdown() {
  setInterval(function () {
    // Countdown per 1 second
    const currentDate = new Date().getTime(); //Get current timestamp

    const timeDiff = countdownDate - currentDate; //Get time difference

    /// Calculate the times
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    dayWrapEl.textContent = `${days} Days`;
    hrsWrapEl.textContent = `${hours} Hrs`;
    minWrapEl.textContent = `${minutes} Min`;
    secWrapEl.textContent = `${seconds} Sec`;
  }, 1000);
}

countdown();

// Tab containers
const tab1 = document.querySelector('#tab-1');
const tab2 = document.querySelector('#tab-2');
const tab3 = document.querySelector('#tab-3');
const tab4 = document.querySelector('#tab-4');

// Tab buttons
const tabBtn1 = document.querySelector('#tabBtn-1');
const tabBtn2 = document.querySelector('#tabBtn-2');
const tabBtn3 = document.querySelector('#tabBtn-3');
const tabBtn4 = document.querySelector('#tabBtn-4');

const enableFunc = function () {};

tabBtn1.addEventListener('click', function (e) {
  e.target.classList.add('active');
  tabBtn2.classList.remove('active');
  tabBtn3.classList.remove('active');
  tabBtn4.classList.remove('active');

  tab1.classList.add('tab_active');
  tab1.classList.remove('tab_deActive');

  tab2.classList.add('tab_deActive');
  tab2.classList.remove('tab_active');

  tab3.classList.add('tab_deActive');
  tab3.classList.remove('tab_active');

  tab4.classList.add('tab_deActive');
  tab4.classList.remove('tab_active');
});

tabBtn2.addEventListener('click', function (e) {
  e.target.classList.add('active');
  tabBtn1.classList.remove('active');
  tabBtn3.classList.remove('active');
  tabBtn4.classList.remove('active');

  tab2.classList.add('tab_active');
  tab2.classList.remove('tab_deActive');

  tab1.classList.add('tab_deActive');
  tab1.classList.remove('tab_active');

  tab3.classList.add('tab_deActive');
  tab3.classList.remove('tab_active');

  tab4.classList.add('tab_deActive');
  tab4.classList.remove('tab_active');
});

tabBtn3.addEventListener('click', function (e) {
  e.target.classList.add('active');
  tabBtn1.classList.remove('active');
  tabBtn2.classList.remove('active');
  tabBtn4.classList.remove('active');

  tab3.classList.add('tab_active');
  tab3.classList.remove('tab_deActive');

  tab1.classList.add('tab_deActive');
  tab1.classList.remove('tab_active');

  tab2.classList.add('tab_deActive');
  tab2.classList.remove('tab_active');

  tab4.classList.add('tab_deActive');
  tab4.classList.remove('tab_active');
});

tabBtn4.addEventListener('click', function (e) {
  e.target.classList.add('active');
  tabBtn1.classList.remove('active');
  tabBtn2.classList.remove('active');
  tabBtn3.classList.remove('active');

  tab4.classList.add('tab_active');
  tab4.classList.remove('tab_deActive');

  tab1.classList.add('tab_deActive');
  tab1.classList.remove('tab_active');

  tab2.classList.add('tab_deActive');
  tab2.classList.remove('tab_active');

  tab3.classList.add('tab_deActive');
  tab3.classList.remove('tab_active');
});
